__turbopack_context__.v({
  "author": "qaDeIa_author",
  "author-photo": "qaDeIa_author-photo",
  "big": "qaDeIa_big",
  "category": "qaDeIa_category",
  "cover": "qaDeIa_cover",
  "details": "qaDeIa_details",
  "info": "qaDeIa_info",
  "name": "qaDeIa_name",
  "recommended": "qaDeIa_recommended",
  "small": "qaDeIa_small",
  "subtitle": "qaDeIa_subtitle",
  "thumbnail": "qaDeIa_thumbnail",
  "time": "qaDeIa_time",
  "title": "qaDeIa_title",
});
